import { render, staticRenderFns } from "./CoreMainLayout.vue?vue&type=template&id=d88963d6&scoped=true&"
import script from "./CoreMainLayout.vue?vue&type=script&lang=ts&"
export * from "./CoreMainLayout.vue?vue&type=script&lang=ts&"
import style0 from "./CoreMainLayout.vue?vue&type=style&index=0&id=d88963d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88963d6",
  null
  
)

export default component.exports